<template>
    <!-- toast -->
    <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
    <!-- end toast -->
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center">
                <h5 class="mb-0 text-primary" data-toggle="modal"
          data-target=".bs-example-modal-lg"><i class="fas fa-file-alt text-primary"></i> Payment Details</h5>
            </div>
            <hr />
            <div class="row g-3">
                <div class="col-md-3">
                    <label class="form-label">Account Type<sup><span class="text-danger font-12">*</span></sup>
                        :</label>
                    <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.pmtType">
                        <option selected=""></option>
                        <option value="Bank Account">
                            Bank Account
                        </option>
                        <option value="Phone Pay">
                            Phone Pay
                        </option>
                        <option value="Google Pay">Google Pay</option>
                        <option value="Paytm">Paytm</option>
                        <option value="UPI">UPI</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Display Name<sup><span class="text-danger font-12">*</span></sup>
                        :</label>
                    <input type="text" class="form-control form-control-sm" v-model="Obj.Name" />

                </div>
                <div class="col-md-3">
                    <label class="form-label">Number :</label>
                    <input type="number" class="form-control form-control-sm"  @input="limitDigits($event, 10, v => Obj.pmtNo = v)" v-model="Obj.pmtNo" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Details<sup><span class="text-danger font-12">*</span></sup>
                        :</label>
                    <textarea type="text" class="form-control form-control-sm" v-model="Obj.details" ></textarea>
                </div>
                <div class="col-md-3">
                    <label class="form-label me-2">Primary :</label>
                    <input type="checkbox" class="form-check-input" v-model="Obj.primary" />
                </div>
                <div class="col-md-3">
                    <label class="form-label">Scanner :</label>
                   <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
             <div class="d-flex align-items-start">
          <a v-if="Obj.image" :href="getUrl(Obj.image)" target="_blank"  class="clearfix">{{Obj.image.substring(Obj.image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.image !== ''" @click="deleteFile(Obj.image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
        <div class="col-md-6 mt-5 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"> <i class="fa fa-save"></i> Save </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
            </div>
            <ul v-if="errors.length" class="text-danger ps-3">
                    <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
                </ul>
            <div class="row">
                <div class="col-md-12 table-responsive mt-2">
                  <div class="progress mb-0 progress-sm" v-if="progress!=0">
                    <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
                      :style="{ width: progress + '%' }"></div>
                  </div>
                     <DataTable v-if="progress==0"  :columns="cols" :rows="rows" :pageSize="10"   :actions="{  view: handleView, edit: handleEdit, delete: handleDelete }" />
                </div>
            </div>
        </div>
    </div>
   <div v-if="PaymentModal" class="modal-backdrop-div">
  <div class="modal-box modal-box-lg">
    <div class="modal-content ms-3">
      <div class="modal-header mt-3 mb-2">
        <h5 class="modal-title text-primary">{{ modalObj.pmtType }} Details</h5>
        <button type="button" class="btn-close ms-auto me-5" data-dismiss="modal" aria-label="Close" @click="closeModal"></button>
      </div>
      <div class="modal-body" v-if="modalObj.pmtType === 'Bank Account'" ref="modalTable">
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-12">
              <p> <span>Account Holder Name: {{ modalObj.Name }}</span><br> 
                <span class="text-dark" v-for="(item, index) in modalObj.details.split(',')" :key="index">
                 {{ item.trim() }}<br> </span>
             </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body" v-else ref="modalTable">
        <div class="row">
          <div class="col-md-6 mt-3" v-if="modalObj.image">
            <p class="mb-0"><strong>Scanner:</strong></p>
            <img :src="getUrl(modalObj.image)" class="w-75 mt-0" />
          </div>
          <div class="col-md-6 mt-5">
            <div class="col-md-12 ">
              <p><strong>UPI/Details:</strong> <span class="text-primary">{{ modalObj.details }}</span></p>
            </div>
            <div class="col-md-12">
              <p><strong>Display Name:</strong> <span class="text-primary">{{ modalObj.Name }}</span></p>
            </div>
            <div class="col-md-12">
              <p v-if="modalObj.pmtNo"><strong>Number:</strong> <span class="text-primary">{{ modalObj.pmtNo }}</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-info me-5 mb-3" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</div>
     <div v-if="showModal" class="modal-backdrop-div">
      <div class="modal-box modal-box-lg">
        <div class="modal-content ms-2">
          <div class="modal-header mt-3 mb-3">
            <h5 class="modal-title text-primary">{{ viewobj.pmtType }} Details</h5>
            <button type="button" class="btn-close me-5 ms-auto" data-dismiss="modal" aria-label="Close" @click="closeModal"> </button>
          </div>
          <div class="modal-body" v-if="viewobj.pmtType === 'Bank Account'" >
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-12">
              <p> <span>Account Holder Name: {{ viewobj.Name }}</span><br> 
                <span class="text-dark" v-for="(item, index) in viewobj.details.split(',')" :key="index">
                 {{ item.trim() }}<br> </span>
             </p>
            </div>
          </div>
        </div>
      </div>
          <div class="modal-body" v-else >
                <div class="row">
                    <div class="col-md-6" v-if="viewobj.image">
                      <p class="mb-0"><strong>Scanner:</strong></p>
                    <img :src="getUrl(viewobj.image)"  class="w-75"/>
                </div>
                <div class="col-md-6 mt-5">
                    <div class="col-md-12">
                        <p><strong>UPI/Details:</strong> <span class="text-primary">{{ viewobj.details }}</span>
                        </p>
                    </div>
                    <div class="col-md-12">
                        <p><strong>Display Name:</strong> <span class="text-primary">{{ viewobj.Name }}</span></p>
                    </div>
                    <div class="col-md-12">
                        <p v-if="viewobj.pmtNo"><strong>Number:</strong> <span class="text-primary">{{ viewobj.pmtNo }}</span></p>
                    </div>
                </div>
                </div>
                </div>
                 <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-info me-5 mb-3" @click="closeModal">Close</button>
            </div>
        </div>
      </div>
    </div>
    <DelPopup :name="delObj.pmtType" @delRecord="delRecord" @closeModal="delObj.pmtType = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import { useFileUpload } from '@/utils/fileUpload';
const { handleFileUploadImg } = useFileUpload()
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( {pmtType: "", details: "",Name:"", pmtNo: "", image: "",primary: false, })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   viewobj = ref({})
    const   errors= ref({})
    const PaymentModal = ref(true)
     const showModal= ref(false)
     const modalShown = ref(false);
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Account Type', key: 'pmtType' },
  { label: 'Details', key: 'details',truncatable: true },
   { label: 'Name', key: 'Name' },
  { label: 'Number', key: 'pmtNo' },
  { label: 'Scanner', key: 'image', type: "image" }
]);
const handleView = (row) => {
    viewobj.value={...row}
    showModal.value = true;
}
const closeModal = () => {
  showModal.value = false;
  PaymentModal.value= false
}
const handleEdit = (row) => {
    Obj.value = { ...row }
     if (Obj.value.image?.startsWith(process.env.VUE_APP_API_URL)) {
    Obj.value.image = Obj.value.image.replace(process.env.VUE_APP_API_URL, '');
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.image = uploadedFile; }
  event.target.value = null;
};
const rows=ref([])
const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
const save = async () => {
  const fields = {
    AccountType: { value: Obj.value.pmtType, validators: [isRequired] },
    DisplayName: { value: Obj.value.Name, validators: [isRequired] },
    pmtNo: { value: Obj.value.pmtNo, validators: [ (v) => { if (v && v.length !== 10) return "Payment No. must be 10 digits"; return null;  }, ], },
    Details: { value: Obj.value.details, validators: [isRequired] },
  };
  errors.value = validateForm(fields);

  if (Object.keys(errors.value).length === 0) {
    if (Obj.value.primary) {
      const existingPrimary = rows.value.find( (item) => item.primary === true && item._id !== Obj.value._id );
      if (existingPrimary) {
          await api.put(`/pmtdetails/${existingPrimary._id}`, { ...existingPrimary, primary: false, });
      }
    }
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/pmtdetails${url}`, Obj.value)
      .then(() => {
        reset();
        loadData();
        msgObj.value = { msg: `Payment ${msg} Successfully`, role: "success", show: true, };
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const reset = async() => {
    Obj.value = { pmtType: "", details: "",Name:"", pmtNo: "", image: "",payment:"",primary: false };
    msgObj.value = { msg: "", role: "", show: false, };
    errors.value={};
}
 const progress = ref(0)
const modalObj = ref({})   
const loadData = async () => {
  let direction = 1
  let progressInterval = setInterval(() => {
    progress.value += direction
    if (progress.value >= 100) {
      progress.value = 0 
    }
  }, 100)

  await api.get('/pmtdetails/all').then((response) => {
    rows.value = response.data.map((item, i) => ({
      ...item,
      Sno: i + 1,
      image: item.image,
    }));
    progress.value = 0
    clearInterval(progressInterval)

    if (rows.value.length > 0) {
      const primaryRecord = rows.value.find((item) => item.primary === true);
      modalObj.value = primaryRecord ? primaryRecord : rows.value[0]
      if (!modalShown.value) {
        PaymentModal.value = true;
        modalShown.value = true;
      } 
    } else {
      PaymentModal.value = false
    }
    reset() 
  });
};

const delRecord = async() => {
    await api.delete(`/pmtdetails/${delObj.value._id}`)
        .then(() => {
            loadData();
            delObj.value={};
            msgObj.value = { msg: "Payment Deleted Successfuly.", role: "danger", show: true, };
        });
}
const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
const getUrl= (img)=> {
    let imgUrl = img.startsWith("..")
            ? img.substring(2)
            : img;
   
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
  onMounted(() => { loadData(); })
</script>